import React from 'react';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import { Badge } from '../../../components/Badge';
import { Icon } from '../../../subkit-ui';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var LandingPageCheckmarkList = function LandingPageCheckmarkList(props) {
  return /*#__PURE__*/_jsxs("div", {
    className: classNames('bg-teal-900 text-white pt-12 flex flex-column items-center px-4 md:px-0', {
      'mt-40 md:mt-96': !isEmpty(props.providerExamples)
    }),
    children: [!isEmpty(props.providerExamples) ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        className: "w-full md:w-3/5 md:mx-auto flex justify-end -mt-40 mb-16 md:-mt-96 md:mb-0",
        children: /*#__PURE__*/_jsx("img", {
          className: "w-56 h-auto max-w-full mx-auto md:ml-0 md:mr-20",
          src: "https://subkit-images.s3.amazonaws.com/images/see_subkit_in_action.svg",
          alt: "See Subkit in Action"
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "mt-4 mb-18 md:grid md:grid-cols-3 md:max-w-3/5 md:gap-6",
        children: props.providerExamples.map(function (example) {
          return /*#__PURE__*/_jsxs("div", {
            className: "flex flex-column mb-8 md:mb-0",
            children: [/*#__PURE__*/_jsx("img", {
              src: example.imageUrl,
              className: "rounded-lg w-full"
            }), /*#__PURE__*/_jsx("div", {
              className: "flex flex-row mt-6 mb-2",
              children: example.categories.map(function (category, index) {
                return /*#__PURE__*/_jsx("div", {
                  className: classNames({
                    'ml-2': index !== 0
                  }),
                  children: /*#__PURE__*/_jsx(Badge, {
                    label: category.name,
                    theme: category.theme
                  })
                }, "".concat(category, "-").concat(index));
              })
            }), /*#__PURE__*/_jsx("div", {
              className: "text-base font-dmsans text-white",
              children: example.serviceName
            }), /*#__PURE__*/_jsx("div", {
              className: "text-base font-dmsans text-white",
              children: "by ".concat(example.providerFirstName)
            })]
          }, "".concat(example.providerFirstName, "-").concat(example.serviceName));
        })
      })]
    }) : null, /*#__PURE__*/_jsxs("div", {
      className: "flex flex-column",
      children: [/*#__PURE__*/_jsx("img", {
        src: "/images/landing-checklist-image.png",
        className: "self-center",
        style: {
          maxWidth: '140px'
        }
      }), /*#__PURE__*/_jsx("div", {
        className: "mx-auto mt-6 max-w-full md:max-w-threequarters font-serif text-1.75rem md:text-2rem leading-snug md:leading-snug text-center text-white",
        children: props.title
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: "mt-4 md:mt-6 mb-18 md:grid md:grid-cols-2 md:max-w-3/5 md:gap-8",
      children: props.listItems.map(function (item) {
        return /*#__PURE__*/_jsxs("div", {
          className: "flex flex-column",
          children: [/*#__PURE__*/_jsxs("div", {
            className: "mt-8 flex text-xl ",
            children: [/*#__PURE__*/_jsx("div", {
              className: "my-0 md:my-auto text-white",
              children: /*#__PURE__*/_jsx(Icon, {
                name: "check"
              })
            }), /*#__PURE__*/_jsx("div", {
              className: "ml-4 font-dmsans leading-snug text-white",
              children: item
            })]
          }), /*#__PURE__*/_jsx("div", {
            className: "flex-1"
          })]
        }, item);
      })
    })]
  });
};

export default LandingPageCheckmarkList;